module.exports = __webpack_public_path__ + "img/connect-chatgpt.7088f14b.svg";